// Replace these urls with your own deployment [don't give the last slash]

module.exports = {
    API_URL: 'https://jiosaavn-api.vercel.app'
}